import { render } from "./PaymentSettings.vue?vue&type=template&id=7ed908e9&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=js"
export * from "./PaymentSettings.vue?vue&type=script&lang=js"

import "./PaymentSettings.vue?vue&type=style&index=0&id=7ed908e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed908e9"]])

export default __exports__